import { LeadersClub } from '@features/landing/grandprix/ui/components/LeadersClub/LeadersClub';
import { LeadersWidget } from '@features/landing/grandprix/ui/components/Leaders';
import { LeaderboardProvider } from '@features/landing/grandprix/providers/LeaderboardProvider';
import { useCustomMediaQuery } from '@libs/hooks/useCustomMediaQuery';

const MEDIA_QUERIES: Record<'small' | 'medium' | 'large', string> = {
  // Используем кастомные брейкпойнты, чтобы везде всё хорошо влезало
  large: '(min-width: 1192px)',
  medium: '(max-width: 1191px) and (min-width: 720px)',
  small: '(max-width: 719px)',
};

export function LeadersClubWidget() {
  const size = useCustomMediaQuery(MEDIA_QUERIES, 'large');

  return (
    <LeaderboardProvider>
      <LeadersClub
        leaders={<LeadersWidget size={size} preset="club" />}
        size={size}
      />
    </LeaderboardProvider>
  );
}
